import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import { useLocation } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "@hooks/use-store";
import { setAdsForceRefresh, setCurrentAdsPage } from "@store/app/app.slice";

import { useGetAdsQuery } from "../../api/ads";

type PropsTypeWrapperAdsBanner = {
  children: React.ReactNode;
  page: string;
};

function WrapperAdsBanner({ children, page }: PropsTypeWrapperAdsBanner) {
  const dispatch = useAppDispatch();
  const { currentAdsPage, adsForceRefresh } = useAppSelector(
    (state) => state.app,
  );
  const { data, isLoading } = useGetAdsQuery(
    {
      page: currentAdsPage,
    },
    {
      skip: !currentAdsPage,
    },
  );

  const [injectScripts, setInjectScripts] = useState<string>("");
  const [refreshScripts, setRefreshScripts] = useState<string>("");

  const inject = (script: string) => {
    if (document.querySelectorAll("#inject-script").length > 0) {
      return;
    }
    document.getElementById("inject-script")?.remove();
    const divFragment = document
      .createRange()
      .createContextualFragment(`<div id="inject-script">${script}</div>`);
    // .createContextualFragment(script);
    document.body.append(divFragment);
  };

  const refresh = (script: string) => {
    const tag = document.getElementById("reload-script");
    if (tag?.innerHTML === script) {
      return;
    }

    tag?.remove();
    const refreshFragment = document
      .createRange()
      .createContextualFragment(`<div id="reload-script">${script}</div>`);

    document.body.append(refreshFragment);
  };

  useLayoutEffect(() => {
    if (page && currentAdsPage !== page) {
      dispatch(setCurrentAdsPage(page));
    }
  }, [currentAdsPage, dispatch, page]);

  useEffect(() => {
    if (!isLoading && !data && currentAdsPage !== page) {
      return;
    }
    if (data && data.scripts.load.length !== injectScripts.length) {
      setInjectScripts(data.scripts.load);
    }
    if (data && data.scripts.refresh !== refreshScripts) {
      setRefreshScripts(data.scripts.refresh);
    }
  }, [
    isLoading,
    data,
    injectScripts.length,
    refreshScripts,
    currentAdsPage,
    page,
  ]);

  useEffect(() => {
    if (adsForceRefresh) {
      const tag = document.getElementById("reload-script");
      if (tag) {
        tag.remove();
      }
      dispatch(setAdsForceRefresh(false));
    }
  }, [adsForceRefresh, dispatch]);

  useEffect(() => {
    if (injectScripts) {
      inject(injectScripts);
    }
  }, [injectScripts]);

  useEffect(() => {
    if (refreshScripts) {
      refresh(refreshScripts);
    }
  }, [refreshScripts]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}

export default WrapperAdsBanner;
